import { View } from 'foundations-components/components/View';
import styled from 'foundations-theming/utils';
import { MerchCardColumns } from 'pricing-pages-ui-components/components/MerchCardColumns';
import { useIsMobile } from 'pricing-pages-ui-components/hooks/useMedia';
import { Children } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const MobileCarouselContainer = styled.div.withConfig({
  displayName: "PublicHubMerchCardLayout__MobileCarouselContainer"
})(({
  theme
}) => ({
  display: 'flex',
  overflowX: 'auto',
  scrollSnapType: 'x mandatory',
  scrollPadding: `0 ${theme.space[400]}`,
  WebkitOverflowScrolling: 'touch',
  gap: theme.space[300],
  paddingBlockStart: theme.space[500],
  paddingBlockEnd: theme.space[100],
  marginInline: `-${theme.space[400]}`,
  '&::-webkit-scrollbar': {
    display: 'none'
  },
  scrollbarWidth: 'none',
  '&::before, &::after': {
    content: '""',
    flex: `0 0 ${theme.space[100]}`
  }
}));
const MobileCarouselItem = styled.div.withConfig({
  displayName: "PublicHubMerchCardLayout__MobileCarouselItem"
})({
  flex: '0 0 min(80%, 475px)',
  scrollSnapAlign: 'center'
});
export const PublicHubMerchCardLayout = ({
  children,
  columns,
  'data-test-id': dataTestId = 'public-merch-card-layout'
}) => {
  const isMobile = useIsMobile();
  if (isMobile) {
    return /*#__PURE__*/_jsx(View, {
      position: "relative",
      "data-test-id": dataTestId,
      children: /*#__PURE__*/_jsx(MobileCarouselContainer, {
        children: Children.map(children, child => /*#__PURE__*/_jsx(MobileCarouselItem, {
          children: /*#__PURE__*/_jsx(MerchCardColumns, {
            columns: 1,
            children: child
          })
        }))
      })
    });
  }
  return /*#__PURE__*/_jsx(View, {
    position: "relative",
    "data-test-id": dataTestId,
    children: /*#__PURE__*/_jsx(MerchCardColumns, {
      columns: columns,
      children: children
    })
  });
};